import { Navigate } from "react-router-dom";
import Dashboard from "../Screens/User/Dashboard";
import Profile from "../Screens/User/Profile";
import Login from "../Screens/Auth/Login";
import SignUp from "../Screens/Auth/SignUp";
import Agents from "../Screens/User/Agents";
import Services from "../Screens/User/Services";
import Wallet from "../Screens/User/Wallet";
import Support from "../Screens/User/Support";
import User from "../Screens/User/User";
import ResetPasswordPage from "../Components/User/ResetPasswordPage";
import SpecialAgentSignUp from "../Screens/Auth/SpecialAgentSignUp";
import ForgotPasswordPage from "../Components/User/ForgotPasswordPage";
import OtpVerificationPage from "../Components/User/OtpVerificationPage";
import Report from "../Screens/User/Report";

const allRoutes = [
  {
    path: "/dashboard",
    component: <Dashboard />,
    permissions: [],
    roles: ["admin", "agent", "sub-agent", "user"],
    title: "Dashboard",
    showInNav: true,
  },
  {
    path: "/agents",
    component: <Agents />,
    permissions: ["agent-management"],
    roles: ["admin"],
    title: "Agents",
    showInNav: true,
  },
  {
    path: "/sub-agents",
    component: <Agents />,
    permissions: ["sub-agent-management"],
    roles: ["agent"],
    title: "Sub Agents",
    showInNav: true,
  },
  {
    path: "/services",
    component: <Services />,
    permissions: ["services"],
    roles: ["admin", "agent", "sub-agent", "user"],
    title: "Services",
    showInNav: true,
  },
  {
    path: "/wallet",
    component: <Wallet />,
    permissions: ["wallet"],
    roles: ["admin", "agent", "sub-agent", "user"],
    title: "Wallet",
    showInNav: true,
  },
  {
    path: "/support",
    component: <Support />,
    permissions: ["support"],
    roles: ["admin", "agent", "sub-agent", "user"],
    title: "Support",
    showInNav: true,
  },
  {
    path: "/profile",
    component: <Profile />,
    permissions: [],
    roles: ["admin", "agent", "sub-agent", "user"],
    title: "Profile",
    showInNav: false,
    exact: true,
  },

  {
    path: "/users",
    component: <User />,
    permissions: ["user-management"],
    roles: ["admin", "agent"],
    title: "User Management",
    showInNav: true,
  },
  {
    path: "/reports",
    component: <Report />,
    permissions: ["reports-management"],
    roles: ["admin"],
    title: "Reports",
    showInNav: true,
  },
];

const getFilteredRoutes = (role, permissions = []) =>
  allRoutes.filter(
    ({ roles, permissions: routePerms }) =>
      roles.includes(role) &&
      (routePerms.length === 0 ||
        routePerms.every((p) => permissions.includes(p))),
  );

const getNavItems = (role, permissions = []) =>
  allRoutes
    .filter((route) => route.showInNav)
    .filter(
      ({ roles, permissions: routePerms }) =>
        roles.includes(role) &&
        (routePerms.length === 0 ||
          routePerms.every((p) => permissions.includes(p))),
    )
    .map(({ path, title }) => ({ path, title }));

const authRoutes = [
  { path: "/login", component: <Login />, title: "Login" },
  { path: "/signup", component: <SignUp />, title: "Sign Up" },
  {
    path: "/inrperk-signup",
    component: <SpecialAgentSignUp />,
    title: "Sign Up",
  },
  {
    path: "/reset-password/:token",
    component: <ResetPasswordPage />,
    title: "Reset Password",
  },
  {
    path: "/forgot-password",
    component: <ResetPasswordPage />,
    title: "Forgot Password",
  },
  {
    path: "/verify-otp",
    component: <OtpVerificationPage />,
    title: "Otp VerificationPage",
  },

  { path: "/", component: <Navigate to="/dashboard" replace />, title: "Home" },
];
export { authRoutes, allRoutes, getNavItems, getFilteredRoutes };
